import { StylesConfig } from 'react-select';
import { OptionType } from 'components/CustomSelect/types';
import theme from 'theme';

const terminalValueListStyles: StylesConfig<OptionType, false> = {
  option: styles => ({
    ...styles,
    fontSize: '14px',
    fontWeight: 700,
    textAlign: 'right',
  }),
  menu: styles => ({
    ...styles,
    right: 0,
    marginTop: `-${theme.palette.headerCellHeight}`,
  }),
};

export default terminalValueListStyles;
